import { FunctionComponent, h, render, Fragment } from 'preact';
import { useContext, useEffect, useState } from 'preact/hooks';
import { getApi } from '../../../src/ts/libs/getApi';
import { ProductItemProps, Products } from '../context/Product';
import { useFetch } from '../hooks/useFetch';
import { ProductListWrap } from '../product-list-wrap/product-list-wrap';
import { AlternateSellingUnits } from '../types/basket';
import { currency } from '../../../src/ts/libs/currency';

interface MyProductItemProps extends ProductItemProps {
  // alternateSellingUnits?: AlternateSellingUnits;
}

const ProductRow: FunctionComponent<MyProductItemProps> = ({
  stock,
  price,
  url,
  image,
  name,
  code,
  iqid,
  quantity = 1,
  alternateSellingUnits,
  disable,
}) => {
  const [qty, setQuantity] = useState(+quantity);
  const [sellingUnitId, setSellingUnitId] = useState(alternateSellingUnits?.id);
  const { fetchData: addToCart, response: addToCartResponse, error } = useFetch(`${getApi('addToBasket')}`, {});
  const {} = useContext(Products);

  const handleChangeUnit = (e) => setSellingUnitId(e.currentTarget.value);
  const handleChangeQty = (e) => setQuantity(e.currentTarget.value);

  const handleRemoveOne = () => {
    // set the value first
    setQuantity((c) => {
      const newVal = c === 1 ? 1 : +c - 1;
      return newVal;
    });
  };
  const handleAddOne = () => {
    // set the value first
    setQuantity((c) => {
      const newVal = +c + 1;

      return newVal;
    });
  };

  const handleAddToBasket = async () => {
    await addToCart({
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        productCode: iqid,
        quantity: qty,
        sellingUnit: sellingUnitId,
      }),
    });

    const event = new Event('basket-update');
    window.dispatchEvent(event);
  };

  useEffect(() => {}, [addToCartResponse]);

  const currentPrice =
    sellingUnitId && alternateSellingUnits?.sellingUnits && alternateSellingUnits?.sellingUnits.length >= 1
      ? alternateSellingUnits?.sellingUnits.find((su) => su.id.toString() === sellingUnitId.toString())?.price
      : price;

  return (
    <div className="trade-products-table__row">
      <div className="trade-products-table__row-in">
        <div className="trade-products-table__row__img">
          <img src={image?.url ? image.url : '/assets/img/no-photo-product.png'} alt={image?.alt ? image.alt : ''} />
        </div>
        <div className="trade-products-table__row__details">
          <h4>
            <strong>{name}</strong>
            <span>
              <strong>Code: </strong> {code}
            </span>
            <span className="mobile-unit-price">
              <strong>Unit Price:</strong> {currency(+price)}
            </span>
          </h4>
          <form className="form">
            <div className="form-field">
              <label className="form-field__label" htmlFor="quantity">
                Quantity
              </label>
              <div className="quantity-control-single">
                <input name="quantity" id="quantity" type="number" value={qty} onChange={handleChangeQty} />
              </div>
            </div>
          </form>
          <form className="form">
            {alternateSellingUnits?.sellingUnits && alternateSellingUnits?.sellingUnits.length >= 1 && (
              <div className="form-field">
                <label htmlFor="sellingUnit">Selling unit</label>

                <select
                  name="sellingUnit"
                  id="sellingUnit"
                  className="select"
                  onChange={handleChangeUnit}
                  value={sellingUnitId}
                >
                  {alternateSellingUnits?.sellingUnits.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name} {item.price}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </form>
          <p className="text-center desktop-unit-price">
            <strong>Unit Price:</strong> {currency(currentPrice)}
          </p>
          <p className="text-center desktop-sub-total">
            <strong>Subtotal:</strong> {currency(+currentPrice * qty)}
          </p>
          <p className="text-right mobile-sub-total">
            <strong>{currency(+currentPrice * qty)}</strong> Ex VAT
          </p>
          {!disable && (
            <button type="button" className="button button--primary button--icon-left" onClick={handleAddToBasket}>
              <svg viewBox="0 0 36 32" width={24} height={22} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m39.0075 26.8324375 2.9545625-13c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-24.548875l-.572875-2.800625c-.14275-.6980625-.757-1.199375-1.4695625-1.199375h-6.4080625c-.8284375 0-1.5.6715625-1.5 1.5v1c0 .8284375.6715625 1.5 1.5 1.5h4.3676875l4.3905 21.4646875c-1.050375.6040625-1.7581875 1.7366875-1.7581875 3.0353125 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-.979625-.4029375-1.8646875-1.0515-2.5h13.1029375c-.6485.6353125-1.0514375 1.520375-1.0514375 2.5 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-1.38575-.8055-2.58325-1.9736875-3.1503125l.3448125-1.51725c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-16.776125l-.4090625-2h18.3215625c.700375 0 1.3075-.484625 1.4626875-1.1675625z"
                  fill="currentColor"
                  fillRule="evenodd"
                  transform="translate(-6 -8)"
                />
              </svg>
              <span className="button__label">Add</span>
            </button>
          )}
        </div>
      </div>
      {!disable && (
        <button type="button" className="button button--primary button--icon-left" onClick={handleAddToBasket}>
          <svg viewBox="0 0 36 32" width={24} height={22} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m39.0075 26.8324375 2.9545625-13c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-24.548875l-.572875-2.800625c-.14275-.6980625-.757-1.199375-1.4695625-1.199375h-6.4080625c-.8284375 0-1.5.6715625-1.5 1.5v1c0 .8284375.6715625 1.5 1.5 1.5h4.3676875l4.3905 21.4646875c-1.050375.6040625-1.7581875 1.7366875-1.7581875 3.0353125 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-.979625-.4029375-1.8646875-1.0515-2.5h13.1029375c-.6485.6353125-1.0514375 1.520375-1.0514375 2.5 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-1.38575-.8055-2.58325-1.9736875-3.1503125l.3448125-1.51725c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-16.776125l-.4090625-2h18.3215625c.700375 0 1.3075-.484625 1.4626875-1.1675625z"
              fill="currentColor"
              fillRule="evenodd"
              transform="translate(-6 -8)"
            />
          </svg>
          <span className="button__label">{error ? 'Error' : 'Add to order'}</span>
        </button>
      )}
    </div>
  );
};

const LoaderCard = () => <div class="product-row-loader"> </div>;

const ProductListContent = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [period, setPeriod] = useState('3');
  const { loading, products, setSearch, loadingMore } = useContext(Products);

  const handleChangeSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleChangePeriod = (e) => {
    setPeriod(e.target.value);
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    setSearch({
      search: searchTerm,
      period,
    });
  };

  return (
    <Fragment>
      <div className="trade-products-table__header-top">
        <div className="trade-products-table__header--find-products">
          <form className="form" onSubmit={handleSearch}>
            <div className="form-field form-field__label-inline  ">
              <label className="form-field__label" htmlFor="inputName">
                Find products
              </label>
              <input name="inputName" id="inputName" type="text" value={searchTerm} onChange={handleChangeSearch} />
            </div>
          </form>
        </div>
        <div className="trade-products-table__header--purchase-period">
          <form className="form">
            <div className="form-field form-field__label-inline">
              <label className="form-field__label" htmlFor="selectName">
                Purchase period
              </label>
              <select name="selectName" id="selectName" className="select" value={period} onChange={handleChangePeriod}>
                <option value="3">Last 3 months</option>
                <option value="6">Last 6 months</option>
                <option value="12">Last 12 months</option>
              </select>
            </div>
          </form>
        </div>
        <div className="trade-products-table__header--button">
          <button type="button" className={`button ${loading ? 'is-loading' : ''}`} onClick={handleSearch}>
            <svg
              aria-hidden="true"
              viewBox="0 0 48 48"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <title>Search Icon</title>
              <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <path
                  d="M35.671875,32.7495362 L30.9984375,28.076555 C30.7875,27.8656381 30.5015625,27.7484621 30.2015625,27.7484621 L29.4375,27.7484621 C30.73125,26.0939361 31.5,24.0128894 31.5,21.7490479 C31.5,16.3636364 27.1359375,12 21.75,12 C16.3640625,12 12,16.3636364 12,21.7490479 C12,27.1344595 16.3640625,31.4980959 21.75,31.4980959 C24.0140625,31.4980959 26.0953125,30.729421 27.75,29.4357973 L27.75,30.1997852 C27.75,30.4997559 27.8671875,30.7856655 28.078125,30.9965824 L32.7515625,35.6695635 C33.1921875,36.1101455 33.9046875,36.1101455 34.340625,35.6695635 L35.6671875,34.3431306 C36.1078125,33.9025486 36.1078125,33.1901182 35.671875,32.7495362 Z M21.65,27.6488282 C18.3359375,27.6488282 15.65,24.9678401 15.65,21.6494141 C15.65,18.3356752 18.33125,15.65 21.65,15.65 C24.9640625,15.65 27.65,18.3309882 27.65,21.6494141 C27.65,24.963153 24.96875,27.6488282 21.65,27.6488282 Z"
                  id="Search"
                  fill="currentColor"
                />
              </g>
            </svg>
            <span className="button__label">Find products</span>
          </button>
        </div>
      </div>

      <div className="trade-products-table">
        <div className="trade-products-table__header">
          <p>Description</p>
          <div className="trade-products-table__header__details">
            <span />
            <p>Quantity</p>
            <p>Selling unit</p>
            <p>Unit price</p>
            <p>Subtotal</p>
          </div>
        </div>

        {products &&
          products?.length >= 1 &&
          products.filter((item) => item.code !== 'SOS').map((item, index) => <ProductRow key={item.id} {...item} />)}

        {loading && [...Array(4)].map((_, index) => <LoaderCard key={`loader${index}`} />)}
      </div>
    </Fragment>
  );
};
const ProductList = ({ alwaysShowFilters }) => (
  <ProductListWrap
    searchPhrase={null}
    api="myProductFilters"
    defaultSort="New-Old"
    alwaysShowFilters={alwaysShowFilters}
  >
    <ProductListContent />
  </ProductListWrap>
);

try {
  const domContainer = document.querySelector('#my-products');
  if (domContainer) {
    const alwaysShowFilters = !!domContainer?.getAttribute('data-force-filters');
    const productListInner = domContainer.querySelector('.my-products');
    render(<ProductList alwaysShowFilters={alwaysShowFilters} />, domContainer, productListInner);
  }
} catch (e) {
  console.warn(e);
}
